<template>
  <LoadingScreen id="loading-screen" />
  <Navbar />
  <div class="page-content guest-content">
    <h1 class="header-large">Love Pets? We do too!</h1>
    <p class="home-message">Join our growing community now!</p>
    <router-link class="router-link" to="/login?signup=true">
      <Button class="call-to-action-home" text="Sign Up" />
    </router-link>
    <Paw />
    <h2 class="moto">Date, Care, Alert!</h2>
    <div class="info-sections">
      <Paw />

      <div class="info-section" @click="goToPage('/login?signup=true')">
        <Link class="link-btn" text="Date" />
        <p class="section-text">
          Find other people and arrange a meet for you and your pets to play
          together, or talk to someone to learn th eperks of having a pet!
        </p>
      </div>
    </div>
    <div class="info-sections">
      <Paw />

      <div class="info-section" @click="goToPage('/login?signup=true')">
        <Link class="link-btn" text="Care" />
        <p class="section-text">
          Find businesses and other services that will help you take care of
          your pet and its daily needs!
        </p>
      </div>
    </div>
    <div class="info-sections">
      <Paw />
      <div class="info-section" @click="goToPage('/login?signup=true')">
        <Link class="link-btn" text="Alert" />
        <p class="section-text">
          A set of usefull tools to help you
          <span class="bold-text">make a safely daily walk</span> by
          <span class="underlined-text">reporting</span> and
          <span class="underlined-text">spotting</span> the location of folas
          (poisoned baits), lost pets as well as safe routes in your area.
        </p>
      </div>
    </div>
    <Socials />
  </div>
  <div class="page-content user-content">
    <h1 class="header-large">Hello {{ formData.firstName }}!</h1>
    <!-- <p class="home-message">Good to see you back!</p> -->
    <Paw />
    <div class="info-sections">
      <div class="info-section banner" @click="goToPage('/profile')">
        <h2>
          Plan a pet-friendly date in a pet-friendly<br />
          place!
        </h2>
        <p class="section-text">
          Whether you're looking for someone to join you on daily walks with
          your pet, <br />
          or just want your pet to find a friend to play with, <br />
          we are HERE for YOU!
        </p>
      </div>
    </div>
    <Paw />
    <div class="info-sections">
      <div class="info-section" @click="goToPage('/date')">
        <Link class="link-btn" text="Date" />
        <p class="section-text">
          Find other people and arrange a meet for you and your pets to play
          together, or talk to someone to learn th eperks of having a pet!
        </p>
      </div>
    </div>
    <div class="info-sections">
      <div class="info-section" @click="goToPage('/care')">
        <Link class="link-btn" text="Care" />
        <p class="section-text">
          Find businesses and other services that will help you take care of
          your pet and its daily needs!
        </p>
      </div>
    </div>
    <div class="info-sections">
      <div class="info-section" @click="goToPage('/alert')">
        <Link class="link-btn" text="Alert" />
        <div class="tool-description">
          <p>
            A set of usefull tools to help you
            <span class="bold-text">make a safely daily walk</span> by
            <span class="underlined-text">reporting</span> and
            <span class="underlined-text">spotting</span> the location of folas
            (poisoned baits), lost pets as well as safe routes in your area.
          </p>
        </div>
      </div>
    </div>
    <div class="prompt">
      <p>
        Didn't find what you are looking for? Please
        <a href="mailto:dating4pets@protonmail.com" class="underlined-text"
          >let us know</a
        >, we will be happy to hear from you!
      </p>
    </div>
    <div class="tip-of-the-day">
      <h2 class="tip-title">Tip of the day</h2>
      <div class="tip-text">
        {{ totd.tip }}
      </div>
      <p class="tip-source">
        <span>Source:</span>
        {{ totd.source }}
      </p>
    </div>
    <Socials />
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Button from "@/components/Button.vue";
import Paw from "@/components/stylistics/Paw.vue";
import Socials from "@/components/Socials.vue";
import Link from "@/components/Link.vue";
import axios from "axios";
import Swal from "sweetalert2";
import LoadingScreen from "@/components/LoadingScreen.vue";

import privacy_policy_json from "/public/privacy_policy.json";

function toggleContentVisibility() {
  if (localStorage.getItem("jwt") !== null) {
    // USER IS LOGGED IN
    let userContent = document.querySelector(".user-content");
    let guestContent = document.querySelector(".guest-content");

    guestContent.classList.add("invisible");
    userContent.classList.remove("invisible");
  } else {
    let userContent = document.querySelector(".user-content");
    let guestContent = document.querySelector(".guest-content");

    userContent.classList.add("invisible");
    guestContent.classList.remove("invisible");
  }
}

export default {
  name: "Home",
  components: {
    Navbar,
    Button,
    Socials,
    Paw,
    Link,
    // CircularLink,
    LoadingScreen,
  },
  mounted() {
    let title = "Home - Dating4Pets";
    document.title = title;

    let self = this;
    toggleContentVisibility();
    let jwt = localStorage.getItem("jwt");
    if (jwt != null) {
      const headers = {
        Authorization: "Bearer " + jwt,
      };
      axios
        .get(`${process.env.VUE_APP_BACKEND}/users/info`, {
          headers: headers,
        })
        .then(function (res) {
          // console.log(res);
          self.formData.firstName = res.data.firstName;
          self.formData.lastName = res.data.lastName;
          self.formData.email = res.data.email;
          self.formData.age = res.data.age;
          self.formData.profileImage = res.data.profileImage;
          self.formData.tos = res.data.tos;

          setTimeout(() => {
            let loadingScreen = document.querySelector("#loading-screen");
            loadingScreen.classList.add("fade-out");
          }, 1000);

          // console.log(`ToS: ${self.formData.tos} ${typeof self.formData.tos}`);
          if (!self.formData.tos) {
            Swal.fire({
              title: "<strong>Privacy Policy</strong>",
              icon: "info",
              input: "checkbox",
              html: self.privacy_policy.privacy_policy,
              showCloseButton: true,
              focusConfirm: false,
              inputPlaceholder:
                "I've read and agree with the terms and conditions.",
              confirmButtonText: "Agree",
              inputValidator: (result) => {
                return (
                  !result &&
                  "You need to agree with our terms and conditions to continue."
                );
              },
              confirmButtonAriaLabel:
                "I've read and agreed with the terms and conditions.",
            }).then((res) => {
              if (res.isConfirmed) {
                let data = {
                  tos: true,
                };
                headers["content-type"] = "application/json";

                axios
                  .put(`${process.env.VUE_APP_BACKEND}/users/update`, data, {
                    headers: headers,
                  })
                  // .then(function () {})
                  .catch(function (err) {
                    // console.log(err);
                    Swal.fire("An error occured!", `${err}`, "error");
                  });
              }
            });
          }
        })
        .catch((err) => {
          // console.log(err);
          if (err.response) {
            if (err.response.data.statusCode == 401) {
              localStorage.removeItem("jwt");
              self.$router.push("/");
            } else {
              console.log(`Line 244: Error: ${err}`);
              // Swal.fire("Line 237: Error", `${err}`, "error");
              self.$router.push("/");
            }
          } else {
            // console.log("headers:", headers);
            console.log(`Line 250: Error: ${err}`);
            localStorage.removeItem("jwt");
            // Swal.fire("Line 240: Error", `${err}`, "error");
            self.$router.push("/");
          }
        });

      // let privacy_policy = JSON.parse(privacy_policy_json);

      axios
        .get(`${process.env.VUE_APP_BACKEND}/tips`)
        .then((res) => {
          self.totd.tip = res.data[0].totd.tip;
          self.totd.source = res.data[0].totd.source;
        })
        .catch((err) => {
          console.log(`Line 26: Error: ${err}`);
          localStorage.removeItem("jwt");
          // Swal.fire("An error occured", `${err}`, "error");
          self.$router.push("/");
        });
    } else {
      setTimeout(() => {
        let loadingScreen = document.querySelector("#loading-screen");
        loadingScreen.classList.add("fade-out");
      }, 1000);
    }
  },
  methods: {
    goToPage(route) {
      let self = this;
      self.$router.push(route);
    },
  },
  data() {
    return {
      formData: {
        username: "",
        firstName: "",
        lastName: "",
        birthday: "",
        age: "",
        email: "",
        password: "",
        repeatPassword: "",
        formType: "",
        userToken: "",
        profileImage: "string",
        tos: true,
      },
      privacy_policy: privacy_policy_json,
      totd: {
        top: "",
        source: "",
      },
    };
  },
};
</script>

<style>
.page-content {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-block-start: 15rem;
  gap: max(var(--gap), 2rem);
  overflow: visible;
  padding-inline: 1em;
}

.home-message {
  font-size: 1rem;
}
.call-to-action-home {
  transform: scale(1.5);
  margin-block-end: 1rem;
  animation-name: double-pulse-wave;
  animation-duration: 10s;
  animation-iteration-count: infinite;
  /* box-shadow: var(--box-shadow-focus) !important; */
}

.blob-container {
  position: absolute;
  overflow: visible;
}

.router-link {
  overflow: visible;
}

.info-sections {
  display: flex;
  flex-direction: row;
  /* align-items: center; */
  align-items: stretch;
  justify-content: center;
  height: max-content;
  overflow: visible;
  width: 100%;
}

.tools-section {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  overflow: visible;
  width: 100%;
}

.tool {
  min-width: 10em;
  /* width: 100% !important; */
  max-width: 20em;
  padding: 1em;
  cursor: pointer;
  transition: var(--transition);
  border-radius: var(--border-radius);
  background: var(--light-clr);
  box-shadow: var(--light-box-shadow);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.tool:hover,
.tool:focus {
  background: var(--faint-bg);
}

.tool-icon {
  margin-block: 0.5em;
  color: var(--dark-clr);
  width: 2em !important;
  aspect-ratio: 1;
}

.bold-text {
  font-weight: bolder;
}

.info-section {
  /* min-width: 15em;
  width: 30%;
  max-width: 40em; */
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: var(--light-clr);
  box-shadow: var(--light-box-shadow);
}

.section-header {
  margin-block-end: 1em;
}

.section-text {
  line-height: 1.5;
  margin-block-start: 1em;
}

.user-content .info-sections .info-section,
.guest-content .info-sections .info-section {
  padding: 1em;
  border-radius: var(--border-radius);
  transition: var(--transition);
  cursor: pointer;
}

.guest-content .info-sections {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.guest-content .info-sections .info-section {
  margin-block-start: 2em;
}

.guest-content .info-sections .info-section,
.guest-content .info-sections .info-section .link-btn {
  cursor: pointer;
}

.link-btn {
  font-size: 1.2em;
}

.user-content .info-sections .info-section:hover,
.user-content .info-sections .info-section:focus {
  background: var(--faint-bg);
}

.moto {
  font-size: 2em;
  font-weight: bold;
  margin-block-start: 2em;
  max-width: 80%;
}

.guest-content .moto {
  margin-block-start: 4em;
}

.guest-content .info-section {
  margin-block-start: 5em;
  width: 80%;
}

.guest-content .info-section .section-header {
  margin-block-start: 1em;
  /* width: 80%; */
}

.tip-of-the-day {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-width: 15em;
  width: 50%;
  max-width: 60em;
  color: var(--dark-clr);
  background: var(--light-clr);
  box-shadow: var(--light-box-shadow);
  padding: 2em;
  border-radius: 1em;
}

.tip-title {
  margin-block: 1em;
}

.tip-text {
  line-height: 1.5;
}

.tip-source {
  margin-block-start: 1em;
  transform: scale(0.7);
  /* text-emphasis: ; */
}

.tip-source span {
  font-weight: bold;
}

.prompt {
  max-width: 80%;
}

.info-section,
.tool {
  min-width: 15em;
  width: 50%;
  max-width: 60em;
}

@media screen and (max-width: 30rem) {
  .tools-section {
    flex-direction: column;
  }
  h2 {
    font-size: 1.2em;
  }

  .tip-text {
    font-size: 0.9em;
  }
}

@media screen and (max-width: 40rem) {
  .info-sections {
    flex-direction: column;
    align-items: center;
  }
  .info-section {
    margin-block-end: 3em;
  }
  /* .tool {
    width: 60% !important;
  } */
}

.invisible {
  display: none;
}

.privacy-policy-container {
  overflow-y: scroll;
  height: 15em;
  padding-inline: 2em;
  font-size: 0.9rem;
}

.privacy-policy-container ul,
.privacy-policy-container ol,
.privacy-policy-container {
  text-align: start;
}

.privacy-policy-container h1,
.privacy-policy-container h2 {
  text-align: center;
}

.privacy-policy-container li span {
  font-weight: bold;
  text-decoration: underline;
}

.privacy-policy-container ul,
.privacy-policy-container ol,
.privacy-policy-container li {
  position: relative;
  /* list-style-type: initial; */
  line-height: 1.5em;
  overflow: visible;
}

.privacy-policy-container ul,
.privacy-policy-container li {
  padding-inline-start: 0.8em;
}

.companies li {
  list-style-type: lower-roman;
}

.banner {
  width: 80% !important;
  /* cursor: initial !important; */
}

.banner:hover {
  background: var(--light-clr) !important;
}

.prompt a {
  transition: var(--transition);
}
.prompt a:hover {
  color: var(--primary-clr);
}

a.tool {
  min-width: 15em;
  width: 50%;
  max-width: 40em;
}
</style>
